import type * as Api from 'Api'
import { CertificateInvalidFields } from '@/models/'

export const certificateErrorMessages: Dictionary<Dictionary<string>> = {
  fullName: {
    default: 'Допущена ошибка в имени и фамилии',
    required: 'Заполните это поле, пожалуйста',
  },
  email: {
    default: 'Допущена ошибка в электронной почте',
    required: 'Заполните это поле, пожалуйста',
    email: 'Электронная почта введена неверно',
  },
  recipientEmail: {
    default: 'Допущена ошибка в электронной почте',
    required: 'Укажите Email получателя сертификата, пожалуйста',
    email: 'Электронная почта введена неверно',
  },
}

export const certificateErrorHandbook: Api.ErrorsHandbook<
  keyof CertificateInvalidFields
> = {
  fullName: [
    {
      status: 1,
      code: 400,
      message: certificateErrorMessages.fullName.default,
    },
  ],
  email: [
    {
      status: 1,
      code: 400,
      message: certificateErrorMessages.email.default,
    },
  ],
  recipientEmail: [
    {
      status: 1,
      code: 400,
      message: certificateErrorMessages.recipientEmail.default,
    },
  ],
}
